import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
//import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';//ORIGINALE
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { EnvService } from 'src/app/services/env.service';

//import { FingerprintService } from 'src/app/xbase/services/fingerprint.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private env: EnvService,
    //private fingerprintService: FingerprintService,
  ) {
  }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const currentUser = this.authService.isLoggedIn;
      let sw=false;
      if (currentUser) {
          return true;
      }
      // not logged in so redirect to login page with the return url
      //console.log("X4:");
      this.router.navigate(['/signup']);
      return false;
  }


}
